/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskResultsList } from "../funcs/riskResultsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskResultsResult } from "../models/components/listriskresultsresult.js";
import {
  ListRiskResultsRequest,
  ListRiskResultsSecurity,
} from "../models/operations/listriskresults.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListResultsQueryData = ListRiskResultsResult;

export function prefetchRiskListResults(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskResultsRequest | undefined,
  security?: ListRiskResultsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListResultsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListResultsQuery(
  client$: GramCore,
  request?: ListRiskResultsRequest | undefined,
  security?: ListRiskResultsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskListResultsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListResults({
      policyId: request?.policyId,
      chatId: request?.chatId,
      mcpServerId: request?.mcpServerId,
      resultId: request?.resultId,
      executionId: request?.executionId,
      category: request?.category,
      ruleId: request?.ruleId,
      userId: request?.userId,
      externalUserIds: request?.externalUserIds,
      uniqueMatch: request?.uniqueMatch,
      nonAssistant: request?.nonAssistant,
      assistantId: request?.assistantId,
      from: request?.from,
      to: request?.to,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListResultsQueryFn(
      ctx,
    ): Promise<RiskListResultsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskResultsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListResults(
  parameters: {
    policyId?: string | undefined;
    chatId?: string | undefined;
    mcpServerId?: string | undefined;
    resultId?: string | undefined;
    executionId?: string | undefined;
    category?: string | undefined;
    ruleId?: string | undefined;
    userId?: string | undefined;
    externalUserIds?: Array<string> | undefined;
    uniqueMatch?: boolean | undefined;
    nonAssistant?: boolean | undefined;
    assistantId?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "results", "list", parameters];
}
